<template>
  <li
    class="grid grid-cols-12"
  >
    <p class="font-bold col-span-6">{{ account.label }}</p>
    <p class="col-span-3">{{ account.identifier }}</p>
    <p v-if="account.type !== 'accumulation'" class="col-span-2">
      {{ account.taxFree | percent }}
    </p>
    <p v-else class="col-span-2">N/A</p>
    <div class="flex space-x-1 items-center">
      <button
        class="focus:outline-none"
        @click="$emit('edit')"
      >
        <!-- eslint-disable max-len -->
        <svg
          xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
          <!-- eslint-disable max-len -->
          <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
          <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd" />
          <!-- eslint-enable max-len -->
        </svg>
        <!-- eslint-enable max-len -->
      </button>
      <button
        class="focus:outline-none"
        @click="$emit('delete')"
      >
        <!-- eslint-disable max-len -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 text-red-600"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clip-rule="evenodd"
          />
        </svg>
        <!-- eslint-enable max-len -->
      </button>
    </div>
  </li>
</template>
<script>
export default {
  name: 'member-account-display',
  props: {
    account: {
      type: Object,
      required: true,
    },
  },
};
</script>
